export default "__VITE_ASSET__BgEQEVxD__ 1920w";